import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Modal, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap";
import { API_BASE_URL, Assets_URL } from "../../Apicongfig";
import axios from "axios";
import { toast } from "react-toastify";
import { useDestinations } from "../../../context/DestinationsContext";
import { useTranslation } from "react-i18next";
import ImageEditorModal from "./ImageEditorModal";
import { IoImages } from "react-icons/io5";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { French } from "flatpickr/dist/l10n/fr.js";
import { useDraftMeetings } from "../../../context/DraftMeetingContext";
import Creatable from "react-select/creatable";
import { destinationTypeIcons } from "../../Utils/MeetingFunctions";
import { format } from "date-fns";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr"; // replace with your locale if needed
import { RxCross2 } from "react-icons/rx";
import { IoIosBusiness, IoIosRocket } from "react-icons/io";
import { FaBookOpen } from "react-icons/fa6";
import { AiOutlineAudit } from "react-icons/ai";
import { MdOutlineSupport } from "react-icons/md";

// Optional: register the locale
registerLocale("fr", fr);

const AddDestination = ({
  show,
  handleClose,
  currentItem,
  refreshedDestination,
  refreshBudget
}) => {
  console.log("currentItem", currentItem);
  const [loading, setLoading] = useState(false);
  const [destinationName, setDestinationName] = useState(null);
  const [destinationDescription, setDestinationDescription] = useState(null);
  const [destinationClient, setDestinationClient] = useState(null); // value (id or name)
  const [destinationClientId, setDestinationClientId] = useState(null); // value (id or name)
  const [isNewClient, setIsNewClient] = useState(false); // check if created or existing

  const [clientNeed, setClientNeed] = useState(null);
  const [destinationTime, setDestinationTime] = useState(new Date());

  const [budgetInitial, setBudgetInitial] = useState(0);
  const [currency, setCurrency] = useState("EUR");
  const [type, setType] = useState(null);
  const { getDestinations } = useDestinations();
  const [t] = useTranslation("global");
  const [isDisabled, setIsDisabled] = useState(false);
  const userId = parseInt(sessionStorage.getItem("user_id"));
  const [image, setImage] = useState(null);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const fileInputRef = React.useRef(null);
  const [croppedimage, setcroppedImage] = useState(null);
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const [step, setStep] = useState(1);
  const [selectedCard, setSelectedCard] = useState(null);

  const handleDestinationTimeChange = (selectedDates) => {
    console.log("Selected:", selectedDates[0]);
    setDestinationTime(selectedDates[0]);
  };

  const [clientImage, setClientImage] = useState(null);
  const clientImageFileInputRef = useRef(null);

  // const triggerClientImageFileInput = () => {
  //   clientImageFileInputRef.current.click();
  // };

  const handleClientImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setClientImage(URL.createObjectURL(file)); // for preview
      // this ref will automatically have the file stored; no need to store it in state unless used elsewhere
    }
  };

  // const handleClientImageUpload = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setClientImage(reader.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  const { language } = useDraftMeetings();
  let [locale, setLocale] = useState(null);
  if (language === "en") {
    locale = undefined;
  } else {
    locale = French;
  }
  const typeOptions = [
    {
      value: "Business opportunity",
      label: t("destination.businessOppurtunity"),
    },
    {
      value: "Study",
      label: t("destination.study"),
    },
    {
      value: "Audit",
      label: t("destination.audit"),
    },
    {
      value: "Project",
      label: t("destination.project"),
    },
    {
      value: "Accompagnement",
      label: t("destination.accompagnement"),
    },
    {
      value: "Other",
      label: t("destination.other"),
    },
  ];
    const [createAnother, setCreateAnother] = useState(false);
    const handleCheckboxChange = (e) => {
      setCreateAnother(e.target.checked);
    };
  // Handle image selection from file input
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setImage(imageUrl);
      setShowModal(true);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleCloseModal = () => {
    handleClose();
    resetForm();
  };
  const resetForm = () => {
    setClientNeed(null);
    setDestinationDescription("");
    setDestinationClient("");
    setBudgetInitial(0);
    setCurrency("EUR");
    setType(null);
    setImage(null);
    setClientImage(null);
    setcroppedImage(null);
    setStep(1);
    setSelectedCard(null);
  };

  const triggerFileInput = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  useEffect(() => {
    if (currentItem) {
      setDestinationName(
        currentItem?.clients?.name || currentItem?.destination_name
      );
      setDestinationDescription(currentItem?.destination_description);
      setClientNeed(currentItem?.destination_name);
      setClientImage(currentItem?.clients?.client_logo);
      setDestinationClient(currentItem?.clients?.name || currentItem?.client);
      setDestinationClientId(currentItem.clients?.id);

      setBudgetInitial(currentItem?.initial_budget || 0);
      setCurrency(currentItem?.currency || "EUR");
      if (currentItem?.destination_end_date_time) {
        setDestinationTime(new Date(currentItem.destination_end_date_time));
      }
      const currentType = typeOptions.find(
        (opt) => opt.value === currentItem?.destination_type
      );
      if (currentType) {
        const cardIndex = typeOptions.findIndex(
          (opt) => opt.value === currentType.value
        );
        setSelectedCard(cardIndex);
      }
      setImage(currentItem?.banner);
      setcroppedImage(currentItem?.banner);
      setType(
        typeOptions.find(
          (opt) => opt.value === currentItem?.destination_type
        ) || null
      );
      if (currentItem?.user_id === userId || currentItem?.user_id === null) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    } else {
      setDestinationName("");
      setDestinationDescription("");
      setDestinationClient("");
      setIsNewClient(false);
      setClientNeed(null);
      setBudgetInitial(0);
      setCurrency("EUR");
      setType("");
      setImage(null);
      setcroppedImage(null);
      setClientImage(null);
      setIsDisabled(false);
    }
  }, [currentItem,show]);

  const user_id = sessionStorage.getItem("user_id");
  const createDestination = async () => {
    if (!clientNeed) {
      toast.error(t("destination.clientNeedError"));
      return;
    }
    if (!destinationClient) {
      toast.error(t("destination.clientError"));
      return;
    }
    setLoading(true);
    try {
      // const payload = {
      //   destination_name: destinationName,
      //   destination_description: destinationDescription || "",
      //   user_id: user_id,
      // };
      const formData = new FormData();
      formData.append("client_id", destinationClientId || null);
      formData.append("client", destinationClient || null);
      formData.append("destination_name", clientNeed);
      formData.append("client_need", clientNeed);
      formData.append("destination_type", type.value || null);
      formData.append("destination_description", destinationDescription || "");
      formData.append("destination_end_date_time", destinationTime || null);
      formData.append("initial_budget", budgetInitial || 0);
      formData.append("currency", currency || null);
      formData.append("user_id", user_id);
      formData.append("timezone", userTimeZone);

      // Add client image
      if (clientImageFileInputRef.current?.files[0]) {
        formData.append(
          "client_logo",
          clientImageFileInputRef.current.files[0]
        );
      }

      // Convert Base64 string to Blob
      if (croppedimage) {
        const base64Response = await fetch(croppedimage);
        const blob = await base64Response.blob(); // Convert to Blob
        formData.append("banner", blob, "banner.jpg"); // Append the Blob to FormData
      }

      const response = await axios.post(
        `${API_BASE_URL}/destinations`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.status) {
        const data = response?.data?.data;
        if(!createAnother){
          navigate(`/invitiesToMeeting/${data?.id}`);
        }else{
          resetForm();
          if(typeof refreshedDestination === "function"){
            refreshedDestination("Audit")
            refreshedDestination("Other")
            refreshedDestination("Study")
            refreshedDestination("Accompagnement")
            refreshedDestination("Project")
            refreshedDestination("Business opportunity")
          }
        }
        // getDestinations();
        toast.success(t("destination.destinationCreateMsg"));

        setDestinationName("");
        setDestinationClientId(null)
        setClientNeed(null);
        setDestinationDescription("");
        setDestinationClient("");
        setBudgetInitial(0);
        setCurrency("EUR");
        setType("");
      }
    } catch (error) {
      console.log("error creating destination", error);
      toast.error(
        error?.response?.data?.message || "Error while creating mission"
      );
    } finally {
      setLoading(false);
    }
  };
  const updateDestination = async (item) => {
    if (!clientNeed) {
      toast.error(t("destination.clientNeedError"));
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("client_id", destinationClientId || null);
      formData.append("client", destinationClient || null);
      formData.append("destination_name", clientNeed);
      formData.append("client_need", clientNeed);
      formData.append("destination_type", type?.value || null);
      formData.append("destination_description", destinationDescription || "");
      formData.append("destination_end_date_time", destinationTime || null);
      formData.append("initial_budget", budgetInitial || 0);
      formData.append("currency", currency || null);
      formData.append("user_id", user_id);
      formData.append("timezone", userTimeZone);

      formData.append("_method", "PATCH");

      // Add client image
      if (clientImageFileInputRef.current?.files[0]) {
        formData.append(
          "client_logo",
          clientImageFileInputRef.current.files[0]
        );
      } else if (clientImage) {
        formData.append("client_logo", clientImage); // Let backend know to keep the existing logo
      }
      // Convert Base64 string to Blob
     if (croppedimage && !croppedimage.startsWith('http')) {
  try {
    const base64Response = await fetch(croppedimage);
    if (!base64Response.ok) throw new Error('Failed to fetch the Base64 image');
    const blob = await base64Response.blob();
    formData.append("banner", blob, "banner.jpg");
  } catch (error) {
    console.error('Error converting Base64 to Blob:', error);
    toast.error('Failed to process the image');
    setLoading(false);
    return;
  }
}

//       if (croppedimage) {
//   try {
//     const base64Response = await fetch(croppedimage, {
//       headers: {
//         'Accept': '*/*',
//         // 'Accept': 'image/*',
//         // 'Host': 'your-api-host.com', 
//       },
//     });

//     if (!base64Response.ok) {
//       throw new Error('Failed to fetch the Base64 image');
//     }

//     const blob = await base64Response.blob();
//     formData.append("banner", blob, "banner.jpg"); // Append the Blob to FormData
//   } catch (error) {
//     console.error('Error converting Base64 to Blob:', error);
//     toast.error('Failed to process the image');
//     return; // Optionally stop execution if image processing fails
//   }
// }

      // if (croppedimage) {
      //   formData.append("banner", croppedimage);
      // }
      const response = await axios.post(
        `${API_BASE_URL}/destinations/${item.id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            "Content-Type": "multipart/form-data", // Specify the content type for file uploads
          },
        }
      );
      if (response.status) {
        const data = response?.data?.data;
        navigate(`/invitiesToMeeting/${data?.id}`);
        handleClose();

        // getDestinations();
        // ✅ Only call if function exists
        if (typeof refreshedDestination === "function") {
          refreshedDestination();
        }

        if(typeof refreshBudget === "function"){
          refreshBudget();
        }

        toast.success(t("destination.destinationUpdateMsg"));
        setDestinationName("");
        setDestinationDescription("");
        setClientNeed(null);
        setDestinationClient("");
        setBudgetInitial(0);
        setCurrency("EUR");
        setType("");
        setImage(null);
        setClientImage(null);
        setcroppedImage(null);
      }
    } catch (error) {
      console.log("error creating destination", error);
      toast.error(
        error?.response?.data?.message || "Error while updating mission"
      );
    } finally {
      setLoading(false);
    }
  };
  const [usersArray, setUsersArray] = useState([]);

  useEffect(() => {
    // Fetch users to populate the select field
    const fetchUsers = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/get-same-enterprise-users/${sessionStorage.getItem(
            "user_id"
          )}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        if (response.status) {
          setUsersArray(response.data?.data);
        }
      } catch (error) {
        console.log("error fetching users", error);
      }
    };
    fetchUsers();
  }, []);

 
//   const options = usersArray?.map((user) => ({
//   value: user.id,
//   label: user.name,
//   data: {  // Add client_logo in a data object
//     client_logo: user.client_logo // Make sure this matches your data structure
//   }
// }));
const groupedOptions = [
 
  {
    label: "Mon entreprise",
    options: usersArray
      .filter((user) => user.linked_to === "enterprise")
      .map((user) => ({
        value: user.id,
        label: user.name,
        data: {
          client_logo: user.client_logo,
        },
      })),
  },
   {
    label: "Nos clients",
    options: usersArray
      .filter((user) => user.linked_to === "user")
      .map((user) => ({
        value: user.id,
        label: user.name,
        data: {
          client_logo: user.client_logo,
        },
      })),
  }
];


  const formatDateWithCustomTime = (date) => {
    return format(date, "dd/MM/yyyy, HH'h'mm");
  };

  const handleTypeSelect = (type, index) => {
    setType(typeOptions.find((opt) => opt.value === type));
    setSelectedCard(index);
    setStep(2);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={handleCloseModal}
        backdrop="static"
        keyboard={false}
        centered
        className="create-destination-modal"
        size={step === 1 ? "md" : "lg"}
      >
        <Modal.Header className="border-0 pb-0">
          <Modal.Title style={{ fontSize: "20px" }}>
            {step === 1
              ? t("Select Mission Type")
              : currentItem
              ? `${t("invities.update")} ${t(
                  `des_type.${currentItem?.destination_type}`
                )} ${t("for")} ${currentItem?.clients?.name}`
              : `${t("invities.create")} ${type?.label ?? ""}`}
          </Modal.Title>
          <Button
            variant="link"
            onClick={handleCloseModal}
            className="position-absolute end-0 top-0 pe-3 pt-2"
          >
            <RxCross2 size={20} />
          </Button>
        </Modal.Header>

        <Modal.Body>
          {step === 1 ? (
            <Row className="g-3">
              {typeOptions.map((option, index) => {
                // Get the appropriate icon for each option
                const getIcon = () => {
                  switch (option.value) {
                    case "Business opportunity":
                      return (
                        <IoIosBusiness
                          style={{ width: "37px", height: "36px" }}
                          color="#DAE6ED"
                        />
                      );
                    case "Study":
                      return (
                        <FaBookOpen
                          style={{ width: "37px", height: "36px" }}
                          color="#DAE6ED"
                        />
                      );
                    case "Audit":
                      return (
                        <AiOutlineAudit
                          style={{ width: "37px", height: "36px" }}
                          color="#DAE6ED"
                        />
                      );
                    case "Project":
                      return (
                        <IoIosRocket
                          style={{ width: "37px", height: "36px" }}
                          color="#DAE6ED"
                        />
                      );
                    case "Accompagnement":
                      return (
                        <MdOutlineSupport
                          style={{ width: "37px", height: "36px" }}
                          color="#DAE6ED"
                        />
                      );

                    case "Other":
                      return (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="37"
                          height="36"
                          viewBox="0 0 512 512"
                          fill="#DAE6ED"
                        >
                          <g>
                            <g>
                              <g>
                                <path
                                  d="M432,336h-10.84c16.344-13.208,26.84-33.392,26.84-56v-32c0-30.872-25.128-56-56-56h-32c-2.72,0-5.376,0.264-8,0.64V48
        h16V0H0v48h16v232H0v48h187.056l40,80H304v88h192v-96C496,364.712,467.288,336,432,336z M422.584,371.328l-32.472,13.92
        L412.28,352h5.472L422.584,371.328z M358.944,352h34.112L376,377.576L358.944,352z M361.872,385.248l-32.472-13.92L334.24,352
        h5.472L361.872,385.248z M432.008,280C432,310.872,406.872,336,376,336s-56-25.128-56-56h37.424
        c14.12,0,27.392-5.504,37.368-15.48l4.128-4.128c8.304,10.272,20.112,16.936,33.088,18.92V280z M48,192v72h107.176
        c0.128,0.28,0.176,0.584,0.312,0.856L163.056,280H32V48h304v149.48c-18.888,9.008-32,28.24-32,50.52v32h-65.064l-24.816-46.528
        C208.368,222.696,197.208,216,185,216c-10.04,0-18.944,4.608-25,11.712V192H48z M144,208v40H64v-40H144z M360,208h32
        c22.056,0,40,17.944,40,40v15.072c-9.168-2.032-17.32-7.48-22.656-15.48l-8.104-12.152l-17.768,17.768
        c-6.96,6.96-16.208,10.792-26.048,10.792H320v-16C320,225.944,337.944,208,360,208z M16,16h336v16H16V16z M16,312v-16h155.056
        l8,16H16z M256,392h-19.056L169.8,257.712c-1.176-2.36-1.8-4.992-1.8-7.608V249c0-9.376,7.624-17,17-17c6.288,0,12.04,3.456,15,9
        l56,104.992V392z M247.464,296h58.392c1.28,5.616,3.232,10.968,5.744,16H256L247.464,296z M264.536,328h57.952
        c2.584,2.872,5.352,5.568,8.36,8H268.8L264.536,328z M480,480h-32v-32h32V480z M480,432h-32v-32h-16v80H320v-88h-48v-40h45.76
        l-7.168,28.672L376,408.704l65.416-28.032l-7.144-28.56C459.68,353.312,480,374.296,480,400V432z"
                                  fill="#DAE6ED"
                                />
                                <path
                                  d="M160,128v-16h-16.808c-1.04-5.096-3.072-9.832-5.856-14.024l11.92-11.92l-11.312-11.312l-11.92,11.92
        c-4.192-2.784-8.928-4.816-14.024-5.856V64H96v16.808c-5.096,1.04-9.832,3.072-14.024,5.856l-11.92-11.92L58.744,86.056
        l11.92,11.92c-2.784,4.192-4.816,8.928-5.856,14.024H48v16h16.808c1.04,5.096,3.072,9.832,5.856,14.024l-11.92,11.92
        l11.312,11.312l11.92-11.92c4.192,2.784,8.928,4.816,14.024,5.856V176h16v-16.808c5.096-1.04,9.832-3.072,14.024-5.856
        l11.92,11.92l11.312-11.312l-11.92-11.92c2.784-4.192,4.816-8.928,5.856-14.024H160z M104,144c-13.232,0-24-10.768-24-24
        s10.768-24,24-24s24,10.768,24,24S117.232,144,104,144z"
                                  fill="#DAE6ED"
                                />
                                <polygon points="244.28,80 272,80 272,64 235.72,64 203.72,112 176,112 176,128 212.28,12" />
                                <rect x="288" y="64" width="32" height="16" />
                                <path
                                  d="M224,144h-48v48h48V144z M208,176h-16v-16h16V176z"
                                  fill="#DAE6ED"
                                />
                                <rect x="240" y="160" width="32" height="16" />
                                <rect x="288" y="160" width="32" height="16" />
                              </g>
                            </g>
                          </g>
                        </svg>
                      );
                    default:
                      return "✨";
                  }
                };

                return (
                  <Col key={index} md={4}>
                    <Card
                      className="text-center shadow-sm"
                      style={{
                        borderRadius: "10px",
                        height: "138px",
                        width: "100%",
                        maxWidth: "138px",
                        background: "none",
                        cursor: "pointer",
                        border:
                          selectedCard === index ? "2px solid blue" : "none",
                        transform: "scale(1.1)",
                        transition: "transform 0.2s ease-in-out",
                      }}
                      onClick={() => handleTypeSelect(option.value, index)}
                    >
                      <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                        {getIcon()}

                        <Card.Title
                          className="mt-2 solutioncards"
                          style={{
                            textAlign: "center",
                            wordBreak: "break-word",
                          }}
                        >
                          {option.label}
                        </Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          ) : (
            <form className="form">
              {!currentItem && (
                <div
                  className="name"
                  style={{ position: "relative", zIndex: 3 }}
                >
                  <label htmlFor="" className="form-label">
                    Client
                    <small
                      style={{
                        color: "red",
                        fontSize: "15px",
                        marginLeft: "2px",
                      }}
                    >
                      *
                    </small>
                  </label>
                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="client-tooltip">
                                        💡 Commencez à taper pour rechercher un client existant ou
                                        en créer un nouveau automatiquement.
                                      </Tooltip>
                                    }
                                  >
                                 <div>
                  <Creatable
                    className="my-select destination-select-dropdown"
                    classNamePrefix="select"
                    onChange={(option, actionMeta) => {
                      if (option) {
                        if (actionMeta.action === "create-option") {
                          setDestinationClient(option.label);
                          setDestinationClientId(null);
                        } else {
                          setDestinationClient(option.label);
                          setDestinationClientId(option.value);
                        }
                      } else {
                        setDestinationClient(null);
                        setDestinationClientId(null);
                      }
                    }}
                    value={
                      destinationClientId
                        ? groupedOptions.find(
                            (opt) =>
                              Number(opt.value) === Number(destinationClientId)
                          )
                        : destinationClient
                        ? { label: destinationClient, value: destinationClient }
                        : null
                    }
                    options={groupedOptions}
                    isClearable
                     formatOptionLabel={(option, { context }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {/* Show client logo if available */}
      {option.data?.client_logo && (
        <img 
          src={option.data.client_logo.startsWith('http') 
            ? option.data.client_logo 
            : `${Assets_URL}/${option.data.client_logo}`}
          alt={option.label}
          style={{
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            objectFit: 'cover',
            marginRight: '10px'
          }}
        />
      )}
      {/* Client name */}
      <span>{option.label}</span>
    </div>
  )}
                  />
                                  </div>   

                                  </OverlayTrigger>

                </div>
              )}

              <div className="name">
                <label htmlFor="" className="form-label">
                  {t("client_need")}
                  <small
                    style={{
                      color: "red",
                      fontSize: "15px",
                      marginLeft: "2px",
                    }}
                  >
                    *
                  </small>
                </label>
                <input
                  type="text"
                  value={clientNeed}
                  onChange={(e) => setClientNeed(e.target.value)}
                />
              </div>

              <div className="description">
                <label htmlFor="">{t("destination_desc")}</label>
                <textarea
                  placeholder={t("Enter Description")}
                  value={destinationDescription}
                  onChange={(e) => setDestinationDescription(e.target.value)}
                />
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="name">
                    <label className="form-label">
                      {t("destination_end_date")}
                    </label>
                    <DatePicker
                      selected={destinationTime}
                      onChange={(date) => setDestinationTime(date)}
                      showTimeSelect
                      timeFormat="HH:mm"
                      timeIntervals={15}
                      dateFormat="dd/MM/yyyy, HH:mm"
                      timeCaption="Time"
                      locale="fr"
                      placeholderText="Select date and time"
                      className="your-custom-class"
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="name">
                    <label htmlFor="" className="form-label">
                      {t("destination_budget")}?
                    </label>
                    <div
                      className="input-group"
                      style={{ display: "flex", width: "100%" }}
                    >
                      <input
                        type="number"
                        value={budgetInitial}
                        onChange={(e) => setBudgetInitial(e.target.value)}
                        className="form-control"
                        style={{ flex: "4" }}
                      />
                      <select
                        name="currency"
                        className="form-select"
                        value={currency}
                        onChange={(e) => setCurrency(e.target.value)}
                        style={{ width: "50px" }}
                      >
                        <option value="USD">USD ($)</option>
                        <option value="EUR">EUR (€)</option>
                        <option value="GBP">GBP (£)</option>
                        <option value="JPY">JPY (¥)</option>
                        <option value="INR">INR (₹)</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {/*     
                  <div className="description" style={{ marginTop: "15px" }}>
                    <label htmlFor="clientImage" className="form-label">
                      Client Image
                    </label>
                    <input
                      type="file"
                      id="clientImage"
                      accept="image/*"
                      ref={clientImageFileInputRef}
                      onChange={handleClientImageUpload}
                      className="form-control"
                    />
                    {clientImage && (
                      <div style={{ marginTop: "10px" }}>
                        <img
                          src={clientImage}
                          alt="Client Preview"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            borderRadius: "5px",
                          }}
                        />
                      </div>
                    )}
                  </div> */}

              <div className="description">
                <label htmlFor="">{t("Banner")}</label>
                <div
                  className="upload-container"
                  onClick={triggerFileInput}
                  style={{
                    cursor: "pointer",
                    padding: "10px",
                    border: "2px dashed #ccc",
                    textAlign: "center",
                    borderRadius: "5px",
                    height: "200px",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  {!croppedimage ? (
                    <>
                      <IoImages
                        style={{ color: "#0026b1", fontSize: "24px" }}
                      />
                      <span
                        style={{
                          fontSize: "15px",
                          color: "#0026b1",
                          marginLeft: "10px",
                          fontWeight: "bold",
                        }}
                      >
                        {t("invities.uploadImg")}
                      </span>
                    </>
                  ) : (
                    <img
                      src={croppedimage}
                      alt="Selected"
                      style={{ width: "100%", height: "auto" }}
                    />
                  )}
                </div>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  style={{ display: "none" }}
                  ref={fileInputRef}
                />
              </div>

              <div className="d-flex justify-content-end gap-3">
                 {!currentItem && (
            <div className="mt-2">
              <input
                type="checkbox"
                className="form-check-input me-2"
                id="createAnotherCheckbox"
                checked={createAnother}
                onChange={handleCheckboxChange}
              />
              <label
                className="form-check-label"
                htmlFor="createAnotherCheckbox"
              >
                {t("meeting.formState.CreateAnother")}
              </label>
            </div>
          )}
                <Button variant="danger" onClick={() => setStep(1)}>
                  {t("Cancel")}
                </Button>
                <button
                  className="btn"
                    type="button" 

                  style={{
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontWeight: 600,
                    lineHeight: "24px",
                    textAlign: "left",
                    color: " #FFFFFF",
                    background: "#2C48AE",
                    border: 0,
                    outine: 0,
                    padding: "10px 16px",
                    borderRadius: "9px",
                    // marginTop: "1.5rem",
                  }}
                  onClick={() => {
                    currentItem
                      ? updateDestination(currentItem)
                      : createDestination();
                  }}
                >
                  {loading ? (
                    <Spinner
                      as="div"
                      variant="light"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      animation="border"
                      style={{ margin: "2px 12px" }}
                    />
                  ) : (
                    <>
                      {currentItem
                        ? t("invities.update")
                        : t("invities.create")}
                    </>
                  )}
                </button>
              </div>
            </form>
          )}
        </Modal.Body>
      </Modal>

      {image && (
        <ImageEditorModal
          show={showModal}
          handleClose={handleModalClose}
          selectedImage={image}
          setImage={setImage}
          setcroppedImage={setcroppedImage}
        />
      )}
    </>
  );
};

export default AddDestination;
